import { MoneyIcon } from '@assets/svgs/MoneyIcon'
import { PaymentCardIcon } from '@assets/svgs/PaymentCardIcon'
import { BankIcon } from '@assets/svgs/BankIcon'
import { BroadcastIcon } from '@assets/svgs/BroadcastIcon'
import { HandCoinIcon } from '@assets/svgs/HandCoinIcon'
import { DataSheetIcon } from '@assets/svgs/DataSheetIcon'
import { TablitaIcon } from '@assets/svgs/TablitaIcon'
import type { JSX } from 'react'
import { VerifiedUserIcon } from '@assets/svgs/VerifiedUserIcon'
import { ApprovedUserIcon } from '@assets/svgs/ApprovedUserIcon'
import { StethoscopeIcon } from '@phosphor-icons/react'
import UserGear3 from '@assets/svgs/user-gear-3'

interface GroupIconConfig {
  icon: JSX.Element
  color: string
  background: string
}

const IconBox = ({ icon, color, background }: { icon: JSX.Element; color: string; background: string }) => (
  <div
    style={{
      width: '32px',
      height: '32px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color,
      background,
      flexShrink: 0
    }}
  >
    {icon}
  </div>
)

export const getGroupIcon = (code: string) => {
  const iconConfigMap: Record<string, GroupIconConfig> = {
    SAL: {
      icon: <MoneyIcon />,
      color: '#2B6CB0',
      background: '#BEE3F8'
    },
    BEN: {
      icon: <PaymentCardIcon />,
      color: '#6B8E23',
      background: '#D9F99D'
    },
    ENC: {
      icon: <BankIcon />,
      color: '#6D7179',
      background: '#E5E7EB'
    },
    TEMP: {
      icon: <BroadcastIcon />,
      color: '#0EA5E9',
      background: '#BAE6FD'
    },
    EXAM: {
      icon: <StethoscopeIcon size={16} style={{ display: 'block' }} />,
      color: '#079F8E',
      background: '#AEFFEF'
    },
    IND: {
      icon: <HandCoinIcon />,
      color: '#5B21B6',
      background: '#DDD6FE'
    },
    OUT: {
      icon: <DataSheetIcon />,
      color: '#718096',
      background: '#E2E8F0'
    },
    PLR: {
      icon: <TablitaIcon minWidth={15} />,
      color: '#B45309',
      background: '#FFE17D'
    },
    PROJ_ADM: {
      icon: <ApprovedUserIcon />,
      color: '#00796B',
      background: '#E0F2F1'
    },
    PROJ_RES: {
      icon: <VerifiedUserIcon />,
      color: '#757575',
      background: '#EFE9E9'
    },
    CUSTOS_TRABALHISTAS: {
      icon: <UserGear3 />,
      color: '#757575',
      background: '#B6CB78'
    },
  }

  const config = iconConfigMap[code]
  if (!config) return null

  return <IconBox icon={config.icon} color={config.color} background={config.background} />
}
